export const COMMON_STOCK_VALUE = 'Common Stock Value';
export const EQUITY_VALUE = 'Equity Value';
export const METRIC_NOT_AVAILABLE = 'Metric Not Available';
export const VALUE_PROPERTY = 'value';
export const GROWTH_PERCENTAGE_PROPERTY = 'growth_percentage';
